import axios, { type AxiosResponse } from "axios";
import { HardwareItemSchema } from "@/schemas/hardware";
import type { HardwareItemType } from "@/schemas/hardware";
import env from "@/app/config/env";

export interface ServiceHardwareApiType {
  fetchHardware: () => Promise<HardwareItemType[]>;
}

export const serviceHardwareApi: ServiceHardwareApiType = {
  fetchHardware: () => {
    return axios
      .get(`${env.services.portal}/hardware`)
      .then((response: AxiosResponse<unknown[]>) => {
        return response.data.map((item) => HardwareItemSchema.parse(item));
      });
  },
};
